/* eslint-disable */

import storage from 'local-storage-fallback';
import isFinite from 'lodash/isFinite';
import replace from 'lodash/replace';
import round from 'lodash/round';
import startsWith from 'lodash/startsWith';
import floor from 'lodash/floor';
import sortBy from 'lodash/sortBy';
import truncate from 'lodash/truncate';
import React from 'react';
import { captureException } from '../Sentry';

export const timezoneVals = [
  ['Pacific/Honolulu', 'Hawaii-Aleutian'],
  ['America/Juneau', 'Alaska (Juneau)'],
  ['America/Anchorage', 'Alaska (Anchorage)'],
  ['America/Los_Angeles', 'Pacific'],
  ['America/Phoenix', 'Arizona'],
  ['America/Denver', 'Mountain'],
  ['America/Chicago', 'Central'],
  ['America/New_York', 'Eastern'],
  ['America/Indiana/Indianapolis', 'Indiana (Indianapolis)'],
  ['America/Puerto_Rico', 'Puerto Rico'],
  ['America/Regina', 'Saskatchewan'],
  ['America/Halifax', 'Atlantic Time (Canada)'],
  ['America/St_Johns', 'Newfoundland'],
  ['Atlantic/Azores', 'Azores'],
  ['Atlantic/Cape_Verde', 'Cape Verde'],
];

export const stringWithWhiteSpaceToJsx = (str: string) => {
  if (!str) return str;
  const lines = str.split(/\r\n|\r|\n/);
  return lines.map((l, i) => {
    const k = `${l}${i}`;
    return (
      <React.Fragment key={k}>
        {l}
        <br />
      </React.Fragment>
    );
  });
};

export const moneyPrint = (n: any) =>
  isFinite(n)
    ? n.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    : '';
export const phonePrint = (s: any) =>
  s ? s.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : '';

export const moneyPrintRound = (n: any) =>
  n
    ? replace(
        n.toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        /\.\d\d/,
        ''
      )
    : '';

export const moneyPrintWithoutZeros = (n: any) =>
  replace(
    round(parseFloat(n)).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    }),
    /\.00/,
    ''
  );

export const dollarsToCents = (v: any): number => {
  if (v != undefined) {
    return round(parseFloat(replace(v.toString(), ',', '')) * 100);
  }
  return 0;
};

export const normalizeUrl = (url: string) => {
  if (!startsWith(url, 'http://') && !startsWith(url, 'https://')) {
    return `http://${url}`;
  }
  return url;
};

export const parseEmailString = (str: string) => {
  const result = str.match(/(.*) <(.*)>/);
  if (result) {
    return { displayName: result[2], address: result[1] };
  }
  return { address: str };
};

const uiKey = '_pvui';
export const setUIItem = (k: any, v: any) => {
  try {
    const json = storage.getItem(uiKey) || '{}';
    const parsedJSON = JSON.parse(json);
    parsedJSON[k] = v;
    storage.setItem(uiKey, JSON.stringify(parsedJSON));
  } catch (e) {
    captureException(e);
  }
};

export const getUIItem = <T,>(k: any): T | undefined => {
  try {
    const json = storage.getItem(uiKey) || '{}';
    const parsed = JSON.parse(json);
    return parsed[k];
  } catch (e) {
    captureException(e);
  }
};

interface StopPropProps {
  children: any;

  [key: string]: any;
}

export const StopProp = ({ children, ...p }: StopPropProps) => (
  <span {...p} onClick={(e) => e.stopPropagation()}>
    {children}
  </span>
);

export const toDateWithTimezone = ({
  date: dateStr,
  offset,
}: {
  date: string;
  offset: number;
}) => {
  if (dateStr && offset) {
    const [, year, month, date] = dateStr.match(/(\d{4})-(\d{2})-(\d{2})/)!; // this isn't ok, get rid of the bang
    return new Date(
      parseInt(year),
      parseInt(month) - 1,
      parseInt(date),
      floor(offset / 60),
      offset % 60,
      0
    );
  }
};

export const sortSpaces = (spaces: any[]) => sortBy(spaces, [(s) => s.name]);
export const getAuthenticityToken = () =>
  document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

export const stripeAuthUrl = ({
  venue,
  clientId,
  apiHost,
}: {
  venue: any;
  clientId: string;
  apiHost: string;
}) =>
  venue &&
  `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${clientId}&scope=read_write&state=${venue.id}&redirect_uri=${apiHost}/auth/stripe_connect/callback`;

export const limitStringLength = (length: number, str?: string) => {
  if (str == undefined) {
    return str;
  }
  return truncate(str, { length, omission: '' });
};

export const formatPercentageRate = (rate?: number) => {
  if (rate === undefined) {
    return '';
  }
  return `${(rate * 100.0).toFixed(3).replace(/\.?0+$/, '')}%`;
};
